<mat-form-field [class]="classes">
  <mat-label>{{label}}</mat-label>
  <input matInput
         [type]="type"
         [formControl]="inputControl"
         [placeholder]="placeholder"
         [required]="required"
         [disabled]="disabled"
         [attr.maxlength]="maxLength"
         [attr.minlength]="minLength"
         [attr.min]="min"
         [attr.max]="max"
         [attr.step]="step"
         (blur)="onBlur()"
         (input)="onInputChange($event)">
  
  <mat-hint *ngIf="hint" align="start">{{hint}}</mat-hint>
  <mat-hint *ngIf="showMaxLengthHint" align="end">{{inputControl.value?.length || 0}} / {{maxLength}}</mat-hint>
  
  <mat-error *ngIf="inputControl.invalid && (inputControl.dirty || inputControl.touched)">
    {{getErrorMessage()}}
  </mat-error>
</mat-form-field>